import { render, staticRenderFns } from "./TaskBoardNotificationBody.vue?vue&type=template&id=3d8c5512"
import script from "./TaskBoardNotificationBody.vue?vue&type=script&lang=js"
export * from "./TaskBoardNotificationBody.vue?vue&type=script&lang=js"
import style0 from "./TaskBoardNotificationBody.vue?vue&type=style&index=0&id=3d8c5512&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports